import React, { Component } from "react";
import TabbedInstructionHeader from "./TabbedInstructionHeader";

export default class NumericalReasoningInstruction extends Component {
    constructor(props) {
        super(props);
        this.circleClick = this.circleClick.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.forceNumericKeyPressHandler = this.forceNumericKeyPressHandler.bind(this);
    }

    circleClick(tabId) {
        if (!this.props.waitingForSpeech) {
            this.props.setCurrentTab(tabId);
        }
    }

    changeHandler(e) {
        if (e.target.value === "30") {
            this.props.clearDisableNext();
        } else {
            this.props.setDisableNext();
        }
    }

    forceNumericKeyPressHandler(e) {
        if (e.charCode >= 48 && e.charCode <= 57) {
            return false;
        }
        e.preventDefault();
        return true;
    }

    render() {
        const p = this.props;

        return (
            <div className="test-page-content-inner test-page-instruction test-page-numerical-reasoning-instruction" >
                <TabbedInstructionHeader currentTabId={p.currentTabId} elems={p.content.elems[0].elems} circleClick={this.circleClick} />
                <div className="practice-content">
                    {renderPractice(p, this.state, this.forceNumericKeyPressHandler, this.changeHandler)}
                </div>
            </div>
        );
    }
}

function renderPractice(props, state, forceNumericKeyPressHandler, changeHandler) {
    const disabled = props.waitingForSpeech ? "disabled" : "";

    return (
        <div className="practice-content-inner">
            <h2 className="question-title">Question</h2>
            <div className="question">
                {props.content.question}
            </div>
            {renderOptions(props.content.options)}
            <h2 className="answer-title">Answer</h2>
            <input type="text" className="answer-text" maxLength="2" onKeyPress={forceNumericKeyPressHandler} onChange={changeHandler} disabled={disabled} />
        </div>
    );
}

function renderOptions(elems) {
    const items = elems.map(function (elem, index) {
        return renderOption(elem, index);
    });

    return (<div className="options">{items}</div>);
}

function renderOption(elem, index,) {
    return <div key={index}>{elem.text}</div>;
}
